<ul>
  @for (data of datas; track data.name) {
    <li>
      <ng-container *tldLet="findResourceValueByName(data.name) as oldValue">
        {{data.name}}: {{oldValue | numberDot}} => {{data.value | numberDot}} <span class="colorGreen">({{data.value - oldValue | numberDot}})</span>
      </ng-container>
    </li>
  }
</ul>
